// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gyjR","newExpiryDate":"styles_newExpiryDate__3S9zQ","footer":"styles_footer__2S5U2"};